import Service from "../../../../Models/Service";
import Mediator from "../../../../Utilities/Mediator";
import OrderHandler from "../../OrderHandler";

export default class CanvasModal {
	service: Service;
	canvasModalDiv: HTMLDivElement;
	canvas: HTMLCanvasElement;
	ctx: CanvasRenderingContext2D;
	image: HTMLImageElement;
	saveButton: HTMLButtonElement;
	serviceIndex: number;

	constructor(service: Service) {
		this.service = service;
		this.canvasModalDiv = document.querySelector('#canvas-modal');
		this.canvasModalDiv.style.display = "flex";
		this.canvas = document.querySelector("canvas");
		this.ctx = this.canvas.getContext("2d");
		this.image = new Image();
		this.saveButton = document.querySelector('#clear + button');
		this.serviceIndex = OrderHandler.selectedItem.services.findIndex(s => s.id === service.id);

		this.setImageSrc();
		this.addCloseModalClickListener();
		this.addSaveButtonClickListener();
		this.addCanavsEventsListeners();
		this.disableCanvasSaveButton();
	}

	private setImageSrc() {
		this.image.width = this.canvas.width;
		this.image.height = this.canvas.height;
		this.image.crossOrigin = "anonymous";

		let src = OrderHandler.selectedItem.services[this.serviceIndex].imageSrc;
		if (src) {
			this.image.src = `data:image/jpeg;base64,${src}`;
		} else {
			this.image.src = OrderHandler.selectedItem.image;
		}
	}

	private addCloseModalClickListener() {
		const closeImage: HTMLImageElement = this.canvasModalDiv.querySelector('img[alt="close icon"]');
		closeImage.onclick = () => {
			this.canvasModalDiv.style.display = "none";
			Mediator.emit("serviceCostChanged", this.service.id, -1);
			OrderHandler.selectedItem.services[this.serviceIndex].variants.forEach(v => Mediator.emit("variantRemoved", v.id));
			OrderHandler.selectedItem.services[this.serviceIndex].imageSrc = null;
			OrderHandler.removeVariants(OrderHandler.selectedItem.itemId, this.service.id);
		}
	}

	private addSaveButtonClickListener() {
		this.saveButton.onclick = () => {
			this.canvasModalDiv.style.display = "none";
			let imageSrc = this.canvas.toDataURL("image/jpeg", 0.4).split(',')[1];
			OrderHandler.selectedItem.services[this.serviceIndex].imageSrc = imageSrc;
			let total = 0;
			OrderHandler.selectedItem.services[this.serviceIndex].variants.forEach(v => total += v.cost);
			Mediator.emit("serviceCostChanged", this.service.id, total);
			OrderHandler.addSelectedItemToShoppingCart();
			Mediator.emit("variantIsSelected", false, OrderHandler.selectedItem.hasSimpleOrderFlow);
		}
	}

	private addCanavsEventsListeners() {
		const container: HTMLDivElement = document.querySelector("#canvas-container");
		this.canvas.width = container.offsetWidth;
		this.canvas.height = container.offsetHeight;

		document.body.onresize = () => {
			this.canvas.width = container.offsetWidth;
			this.canvas.height = container.offsetHeight;
			this.setImageSrc();
		}

		this.image.onload = () => {
			this.ctx.fillStyle = "#fff";
			this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			this.ctx.globalAlpha = 0.9; // 10% Transparency

			this.ctx.drawImage(this.image,
				this.canvas.width * 0.05,
				this.canvas.width * 0.05,
				this.canvas.width * 0.9,
				this.canvas.height * 0.9);
		}

		const btnClear = document.getElementById("clear");
		btnClear.onclick = () => {
			this.clearCanvas();
		}

		this.canvas.onclick = (event: MouseEvent) => {
			this.markImageArea(event);
		}

		this.canvas.onmousemove = this.moveCirclePointer;
	}

	private markImageArea(event: MouseEvent) {
		const circle: HTMLDivElement = document.querySelector("#mouse-circle");
		let radius: number = circle.offsetWidth / 2;
		this.ctx.beginPath();
		this.ctx.fillStyle = "#343434";
		this.ctx.arc(event.offsetX, event.offsetY, radius, 0, 360);
		this.ctx.fill();
		this.ctx.closePath();
		this.enableCanvasSaveButton();
	}

	private clearCanvas() {
		OrderHandler.selectedItem.services[this.serviceIndex].variants.length = 0;
		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		this.setImageSrc();
		this.ctx.drawImage(this.image, 0, 0, this.canvas.width, this.canvas.height);
		this.disableCanvasSaveButton();
	}

	private enableCanvasSaveButton(): void {
		this.saveButton.style.opacity = "1";
		this.saveButton.disabled = false;
	}

	private disableCanvasSaveButton() {
		this.saveButton.style.opacity = "0.5";
		this.saveButton.disabled = true;
	}

	private moveCirclePointer(event: MouseEvent) {
		let mousePosX = 0,
			mousePosY = 0,
			mouseCircle = document.getElementById('mouse-circle');
		mousePosX = event.offsetX;
		mousePosY = event.offsetY;
		let delay = 1,
			revisedMousePosX = 0,
			revisedMousePosY = 0;

		function delayMouseFollow() {
			requestAnimationFrame(delayMouseFollow);

			revisedMousePosX += (mousePosX - revisedMousePosX) / delay;
			revisedMousePosY += (mousePosY - revisedMousePosY) / delay;

			mouseCircle.style.top = revisedMousePosY + 'px';
			mouseCircle.style.left = revisedMousePosX + 'px';
		}
		delayMouseFollow();
	}
}
